import {createContext} from "react";

const TextractContext = createContext({
  setSnackbar: () => console.warn("markAsChecked not provided"),
});

export default TextractContext;